<div class="position-relative">
  <button
    type="button"
    [coreCustomTooltip]="tooltipText()"
    [class]="'btn ' + btnClass()"
    [disabled]="disabled()"
    [ngClass]="{
      'btn-warning text-black': severity() === 'warning',
      'btn-primary': severity() === 'primary',
      'btn-danger': severity() === 'danger',
      'btn-success': severity() === 'success',
      'btn-bg-light': severity() === 'light',
      'btn-light-primary': severity() === 'light-primary',
      'btn-light-danger': severity() === 'light-danger',
      'btn-light-secondary': severity() === 'light-secondary',
      'btn-secondary': severity() === 'secondary',

      'btn-sm': size() === 'sm',
      'btn-md': size() === 'md',
      'btn-lg': size() === 'lg',
      'btn-xsm': size() === 'xsm',
      'h-auto w-auto bg-transparent': size() === 'auto',

      'btn-outline': outline(),

      'btn-icon': !buttonText() && icon(),
      'd-flex align-items-center justify-content-center': icon(),
      'gap-2': icon() && buttonText(),
    }"
    (click)="handleClick($event)"
  >
    @if (icon() && !isLoading()) {
      <ui-keenicon [name]="icon()" [class]="iconClass()"></ui-keenicon>
    }
    @if (isLoading()) {
      <span
        *transloco="let t; prefix: 'uiKit'"
        class="indicator-progress d-block"
      >
        @if (buttonText()) {
          <span>
            {{ t('placeholders.wait') }}
          </span>
        }
        <span
          [ngClass]="{
            'ms-2': buttonText(),
          }"
          class="spinner-border spinner-border-sm align-middle"
        ></span>
      </span>
    }
    @if (!isLoading()) {
      <span class="indicator-label">{{ buttonText() }}</span>
    }
    <ng-content></ng-content>
  </button>
  @if (counter()) {
    <span class="badge count-badge" [class]="'badge-success'">{{
      counter()
    }}</span>
  }
</div>
